import {
  GET_BUYER_IDENTITY,
  GET_BUYER_IDENTITY_ERROR,
  GET_BUYER_IDENTITY_SUCCESS
} from "./constants";

export function getBuyerIdentity({ userId }) {
  return {
    type: GET_BUYER_IDENTITY,
    userId
  };
}

export function getBuyerIdentityError(err) {
  return {
    type: GET_BUYER_IDENTITY_ERROR,
    err
  };
}

export function getBuyerIdentityDone(identities) {
  return {
    type: GET_BUYER_IDENTITY_SUCCESS,
    identities
  };
}
